export enum FilteringOptionType {
  INCLUSION = 'INCLUSION',
  INTERVAL = 'INTERVAL',
  TIME = 'TIME',
}
